import { AccessAlarmOutlined, AccessibilityNewOutlined, AccessTimeOutlined, AccountBalanceOutlined, AccountBalanceWalletOutlined, AddOutlined, AddToPhotosOutlined, AdjustOutlined, AirOutlined, AirplanemodeActiveOutlined, AltRouteOutlined, AnalyticsOutlined, AndroidOutlined, Apple, ArticleOutlined, AspectRatioOutlined, AttachFileOutlined, AttachMoneyOutlined, AudiotrackOutlined, AutoAwesomeOutlined, BatteryAlertOutlined, BatteryChargingFullOutlined, BatteryFullOutlined, BiotechOutlined, BlockOutlined, BluetoothOutlined, BoltOutlined, BookmarkBorderOutlined, BrushOutlined, BusinessCenterOutlined, CableOutlined, CalculateOutlined, CalendarMonthOutlined, CallOutlined, CameraAltOutlined, CellWifiOutlined, ChatOutlined, ChecklistOutlined, CloudOutlined, CloudSyncOutlined, CodeOutlined, CommitOutlined, CompostOutlined, ConnectWithoutContactOutlined, ConstructionOutlined, ContactlessOutlined, ContactsOutlined, ContentPasteOutlined, CoronavirusOutlined, CreditCardOutlined, CropOutlined, CurrencyBitcoinOutlined, DesktopWindowsOutlined, DevicesOtherOutlined, DirectionsBikeOutlined, DirectionsBusOutlined, DirectionsCarOutlined, Diversity3Outlined, DocumentScannerOutlined, DoneAllOutlined, DownloadOutlined, EditOutlined, EmojiEmotionsOutlined, EnergySavingsLeafOutlined, EuroSymbolOutlined, ExploreOutlined, FavoriteBorderOutlined, FilterTiltShiftOutlined, FingerprintOutlined, FolderOutlined, ForumOutlined, GamepadOutlined, GpsFixedOutlined, GTranslateOutlined, HeadphonesOutlined, HourglassEmptyOutlined, HubOutlined, InsertLinkOutlined, Inventory2Outlined, InventoryOutlined, KeyOutlined, LaptopMacOutlined, LocalFireDepartmentOutlined, LockOutlined, ManageAccountsOutlined, MarkunreadOutlined, MicNoneOutlined, ModeNightOutlined, NavigationOutlined, NetworkCellOutlined, NetworkWifiOutlined, NewspaperOutlined, PeopleOutlined, PhoneAndroidOutlined, PlayCircleOutlineOutlined, PrintOutlined, PublicOutlined, QrCodeOutlined, QrCodeScannerOutlined, QuestionMarkOutlined, ReceiptLongOutlined, RocketLaunchOutlined, SatelliteAltOutlined, SaveOutlined, SavingsOutlined, SecurityOutlined, SendOutlined, SensorsOutlined, SettingsOutlined, ShareOutlined, ShoppingCartOutlined, TranslateOutlined, ViewInArOutlined, WatchOutlined, WebOutlined } from "@mui/icons-material";
import theme from "../style/theme";
import { useState } from "react";
import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import { useTranslation } from "react-i18next";

export const iconCases = [
    'receipt-long',
    'people',
    'cloud-sync',
    'auto-awsome',
    'contacts',
    'forum',
    'inventory',
    'add-photos',
    'filter-tilt',
    'diversity-3',
    'lock',
    'hub',
    'add',
    'alarm',
    'time',
    'accessibility',
    'bank',
    'wallet',
    'adjust',
    'air',
    'airplane',
    'alt-route',
    'analytics',
    'article',
    'aspect-ratio',
    'attach',
    'audio',
    'battery-alert',
    'battery-charging',
    'battery-full',
    'biotech',
    'block',
    'bluetooth',
    'bolt',
    'bookmark',
    'brush',
    'business',
    'cable',
    'calculate',
    'calendar',
    'call',
    'camera',
    'cell-wifi',
    'chat',
    'checklist',
    'cloud',
    'code',
    'commit',
    'compost',
    'connect',
    'construction',
    'contactless',
    'content-paste',
    'coronavirus',
    'credit-card',
    'crop',
    'screen',
    'devices',
    'bus',
    'bike',
    'car',
    'scan',
    'done',
    'download',
    'edit',
    'cup',
    'energy-saving',
    'explore',
    'favorite',
    'fingerprint',
    'folder',
    'g-translate',
    'game-pad',
    'gps',
    'headphones',
    'hourglass',
    'link',
    'inventory-2',
    'key',
    'laptop',
    'fire',
    'manage-account',
    'mail',
    'microphone',
    'moon',
    'navigation',
    'network-cell',
    'network-wifi',
    'newpaper',
    'cell-phone',
    'play',
    'print',
    'public',
    'qr-scan',
    'qr',
    'question',
    'rocket',
    'satellite',
    'save',
    'savings',
    'security',
    'send',
    'sensor',
    'settings',
    'share',
    'cart',
    'translate',
    'view-ar',
    'watch',
    'web',
    'android',
    'apple',
    'dollar',
    'euro'
];

export function MaterialIcon({icon}) {
    const props = {sx: {color: theme.palette.secondary.dark}};

    switch (icon) {
        case 'receipt-long':
            return <ReceiptLongOutlined {...props}/>;
        case 'people':
            return <PeopleOutlined {...props}/>;
        case 'cloud-sync':
            return <CloudSyncOutlined {...props}/>;
        case 'auto-awsome':
            return <AutoAwesomeOutlined {...props}/>;
        case 'contacts':
            return <ContactsOutlined {...props}/>;
        case 'forum':
            return <ForumOutlined {...props}/>;
        case 'inventory':
            return <InventoryOutlined {...props}/>;
        case 'add-photos':
            return <AddToPhotosOutlined {...props}/>;
        case 'filter-tilt':
            return <FilterTiltShiftOutlined {...props}/>;
        case 'diversity-3':
            return <Diversity3Outlined {...props}/>;
        case 'lock':
            return <LockOutlined {...props}/>;
        case 'hub':
            return <HubOutlined {...props}/>;
        case 'add':
            return <AddOutlined {...props}/>;
        case 'alarm':
            return <AccessAlarmOutlined {...props}/>;
        case 'time':
            return <AccessTimeOutlined {...props}/>;
        case 'accessibility':
            return <AccessibilityNewOutlined {...props}/>;
        case 'bank':
            return <AccountBalanceOutlined {...props}/>;
        case 'wallet':
            return <AccountBalanceWalletOutlined {...props}/>;
        case 'adjust':
            return <AdjustOutlined {...props}/>;
        case 'air':
            return <AirOutlined {...props}/>;
        case 'airplane':
            return <AirplanemodeActiveOutlined {...props}/>;
        case 'alt-route':
            return <AltRouteOutlined {...props}/>;
        case 'analytics':
            return <AnalyticsOutlined {...props}/>;
        case 'article':
            return <ArticleOutlined {...props}/>;
        case 'aspect-ratio':
            return <AspectRatioOutlined {...props}/>;
        case 'attach':
            return <AttachFileOutlined {...props}/>;
        case 'audio':
            return <AudiotrackOutlined {...props}/>;
        case 'battery-alert':
            return <BatteryAlertOutlined {...props}/>;
        case 'battery-charging':
            return <BatteryChargingFullOutlined {...props}/>;
        case 'battery-full':
            return <BatteryFullOutlined {...props}/>;
        case 'biotech':
            return <BiotechOutlined {...props}/>;
        case 'block':
            return <BlockOutlined {...props}/>;
        case 'bluetooth':
            return <BluetoothOutlined {...props}/>;
        case 'bolt':
            return <BoltOutlined {...props}/>;
        case 'bookmark':
            return <BookmarkBorderOutlined {...props}/>;
        case 'brush':
            return <BrushOutlined {...props}/>;
        case 'business':
            return <BusinessCenterOutlined {...props}/>;
        case 'cable':
            return <CableOutlined {...props}/>;
        case 'calculate':
            return <CalculateOutlined {...props}/>;
        case 'calendar':
            return <CalendarMonthOutlined {...props}/>;
        case 'call':
            return <CallOutlined {...props}/>;
        case 'camera':
            return <CameraAltOutlined {...props}/>;
        case 'cell-wifi':
            return <CellWifiOutlined {...props}/>;
        case 'chat':
            return <ChatOutlined {...props}/>;
        case 'checklist':
            return <ChecklistOutlined {...props}/>;
        case 'cloud':
            return <CloudOutlined {...props}/>;
        case 'code':
            return <CodeOutlined {...props}/>;
        case 'commit':
            return <CommitOutlined {...props}/>;
        case 'compost':
            return <CompostOutlined {...props}/>;
        case 'connect':
            return <ConnectWithoutContactOutlined {...props}/>;
        case 'construction':
            return <ConstructionOutlined {...props}/>;
        case 'contactless':
            return <ContactlessOutlined {...props}/>;
        case 'content-paste':
            return <ContentPasteOutlined {...props}/>;
        case 'coronavirus':
            return <CoronavirusOutlined {...props}/>;
        case 'credit-card':
            return <CreditCardOutlined {...props}/>;
        case 'crop':
            return <CropOutlined {...props}/>;
        case 'screen':
            return <DesktopWindowsOutlined {...props}/>;
        case 'devices':
            return <DevicesOtherOutlined {...props}/>;
        case 'bus':
            return <DirectionsBusOutlined {...props}/>;
        case 'bike':
            return <DirectionsBikeOutlined {...props}/>;
        case 'car':
            return <DirectionsCarOutlined {...props}/>;
        case 'scan':
            return <DocumentScannerOutlined {...props}/>;
        case 'done':
            return <DoneAllOutlined {...props}/>;
        case 'download':
            return <DownloadOutlined {...props}/>;
        case 'edit':
            return <EditOutlined {...props}/>;
        case 'cup':
            return <EmojiEmotionsOutlined {...props}/>;
        case 'energy-saving':
            return <EnergySavingsLeafOutlined {...props}/>;
        case 'explore':
            return <ExploreOutlined {...props}/>;
        case 'favorite':
            return <FavoriteBorderOutlined {...props}/>;
        case 'fingerprint':
            return <FingerprintOutlined {...props}/>;
        case 'folder':
            return <FolderOutlined {...props}/>;
        case 'g-translate':
            return <GTranslateOutlined {...props}/>;
        case 'game-pad':
            return <GamepadOutlined {...props}/>;
        case 'gps':
            return <GpsFixedOutlined {...props}/>;
        case 'headphones':
            return <HeadphonesOutlined {...props}/>;
        case 'hourglass':
            return <HourglassEmptyOutlined {...props}/>;
        case 'link':
            return <InsertLinkOutlined {...props}/>;
        case 'inventory-2':
            return <Inventory2Outlined {...props}/>;
        case 'key':
            return <KeyOutlined {...props}/>;
        case 'laptop':
            return <LaptopMacOutlined {...props}/>;
        case 'fire':
            return <LocalFireDepartmentOutlined {...props}/>;
        case 'manage-account':
            return <ManageAccountsOutlined {...props}/>;
        case 'mail':
            return <MarkunreadOutlined {...props}/>;
        case 'microphone':
            return <MicNoneOutlined {...props}/>;
        case 'moon':
            return <ModeNightOutlined {...props}/>;
        case 'navigation':
            return <NavigationOutlined {...props}/>;
        case 'network-cell':
            return <NetworkCellOutlined {...props}/>;
        case 'network-wifi':
            return <NetworkWifiOutlined {...props}/>;
        case 'newpaper':
            return <NewspaperOutlined {...props}/>;
        case 'cell-phone':
            return <PhoneAndroidOutlined {...props}/>;
        case 'play':
            return <PlayCircleOutlineOutlined {...props}/>;
        case 'print':
            return <PrintOutlined {...props}/>;
        case 'public':
            return <PublicOutlined {...props}/>;
        case 'qr-scan':
            return <QrCodeScannerOutlined {...props}/>;
        case 'qr':
            return <QrCodeOutlined {...props}/>;
        case 'question':
            return <QuestionMarkOutlined {...props}/>;
        case 'rocket':
            return <RocketLaunchOutlined {...props}/>;
        case 'satellite':
            return <SatelliteAltOutlined {...props}/>;
        case 'save':
            return <SaveOutlined {...props}/>;
        case 'savings':
            return <SavingsOutlined {...props}/>;
        case 'security':
            return <SecurityOutlined {...props}/>;
        case 'send':
            return <SendOutlined {...props}/>;
        case 'sensor':
            return <SensorsOutlined {...props}/>;
        case 'settings':
            return <SettingsOutlined {...props}/>;
        case 'share':
            return <ShareOutlined {...props}/>;
        case 'cart':
            return <ShoppingCartOutlined {...props}/>;
        case 'translate':
            return <TranslateOutlined {...props}/>;
        case 'view-ar':
            return <ViewInArOutlined {...props}/>;
        case 'watch':
            return <WatchOutlined {...props}/>;
        case 'web':
            return <WebOutlined {...props}/>;
        case 'android':
            return <AndroidOutlined {...props}/>;
        case 'apple':
            return <Apple {...props}/>;
        case 'bitcoin':
            return <CurrencyBitcoinOutlined {...props}/>;
        case 'dollar':
            return <AttachMoneyOutlined {...props}/>;
        case 'euro':
            return <EuroSymbolOutlined {...props}/>;
        default:
            return null;
    }
}

export function EditableMaterilIcon({ icon, onChange=(icon)=>{}, canEdit=true }) {
    const { t } = useTranslation();

    const [editing, setEditing] = useState(false);
    const [hover, setHover] = useState(false);

    const handleOpenIconSelection = () => {
        setEditing(true);
    }
    const handleCloseIconSelection = () => {
        setEditing(false);
    }

    return <>
        {canEdit
            ? <Dialog
                open={editing}
                onClose={handleCloseIconSelection}
            >
                <DialogTitle sx={{fontWeight: 'bold'}}>{t('solutions.page.feature.icon')}</DialogTitle>
                <DialogContent>
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(60px, 60px))',
                        gap: '10px',
                        maxWidth: '900px',
                        justifyContent: 'center',
                    }}>
                        {iconCases.map((icon, index) => <div key={index} className="solution-feature-icon clickable" style={{margin: 0}} onClick={() => {
                            onChange(icon);
                            handleCloseIconSelection();
                        }}>
                            <MaterialIcon icon={icon}/>
                        </div>)}
                    </div>
                </DialogContent>
            </Dialog>
            : null
        }
        {canEdit
            ? <div style={{position:'relative', width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: 'inherit'}}>
                <MaterialIcon icon={icon}/>
                <div className='editable-image-overlay' style={{bottom:0}} onMouseEnter={() => {setHover(true)}} onMouseLeave={() => {setHover(false)}} onClick={handleOpenIconSelection}>
                    <div className={`icon-overlay ${hover ? 'hover' : ''}`}>
                        <EditOutlined sx={{color: 'white'}}/>
                    </div>
                </div>
            </div> : <MaterialIcon icon={icon}/>
        }
    </>
}